import * as o from "react";
import { u as I, P as v, c as O, a as S } from "./index-wif4gfZf.js";
import { u as D } from "./index-CCKe-Mpx.js";
import { u as M } from "./index-DLcqcWxM.js";
import { P as L } from "./index-BpWB3aFK.js";
import { u as k } from "./index-Cv867SGx.js";
import { j as c } from "./utils-BdNIfrGQ.js";
var f = "Collapsible", [F, Q] = S(f), [B, g] = F(f), T = o.forwardRef(
  (e, s) => {
    const {
      __scopeCollapsible: r,
      open: a,
      defaultOpen: t,
      disabled: l,
      onOpenChange: i,
      ...m
    } = e, [p, d] = I({
      prop: a,
      defaultProp: t ?? !1,
      onChange: i,
      caller: f
    });
    return /* @__PURE__ */ c.jsx(
      B,
      {
        scope: r,
        disabled: l,
        contentId: k(),
        open: p,
        onOpenToggle: o.useCallback(() => d((C) => !C), [d]),
        children: /* @__PURE__ */ c.jsx(
          v.div,
          {
            "data-state": x(p),
            "data-disabled": l ? "" : void 0,
            ...m,
            ref: s
          }
        )
      }
    );
  }
);
T.displayName = f;
var j = "CollapsibleTrigger", w = o.forwardRef(
  (e, s) => {
    const { __scopeCollapsible: r, ...a } = e, t = g(j, r);
    return /* @__PURE__ */ c.jsx(
      v.button,
      {
        type: "button",
        "aria-controls": t.contentId,
        "aria-expanded": t.open || !1,
        "data-state": x(t.open),
        "data-disabled": t.disabled ? "" : void 0,
        disabled: t.disabled,
        ...a,
        ref: s,
        onClick: O(e.onClick, t.onOpenToggle)
      }
    );
  }
);
w.displayName = j;
var R = "CollapsibleContent", A = o.forwardRef(
  (e, s) => {
    const { forceMount: r, ...a } = e, t = g(R, e.__scopeCollapsible);
    return /* @__PURE__ */ c.jsx(L, { present: r || t.open, children: ({ present: l }) => /* @__PURE__ */ c.jsx(G, { ...a, ref: s, present: l }) });
  }
);
A.displayName = R;
var G = o.forwardRef((e, s) => {
  const { __scopeCollapsible: r, present: a, children: t, ...l } = e, i = g(R, r), [m, p] = o.useState(a), d = o.useRef(null), C = M(s, d), h = o.useRef(0), P = h.current, y = o.useRef(0), N = y.current, b = i.open || m, _ = o.useRef(b), u = o.useRef(void 0);
  return o.useEffect(() => {
    const n = requestAnimationFrame(() => _.current = !1);
    return () => cancelAnimationFrame(n);
  }, []), D(() => {
    const n = d.current;
    if (n) {
      u.current = u.current || {
        transitionDuration: n.style.transitionDuration,
        animationName: n.style.animationName
      }, n.style.transitionDuration = "0s", n.style.animationName = "none";
      const E = n.getBoundingClientRect();
      h.current = E.height, y.current = E.width, _.current || (n.style.transitionDuration = u.current.transitionDuration, n.style.animationName = u.current.animationName), p(a);
    }
  }, [i.open, a]), /* @__PURE__ */ c.jsx(
    v.div,
    {
      "data-state": x(i.open),
      "data-disabled": i.disabled ? "" : void 0,
      id: i.contentId,
      hidden: !b,
      ...l,
      ref: C,
      style: {
        "--radix-collapsible-content-height": P ? `${P}px` : void 0,
        "--radix-collapsible-content-width": N ? `${N}px` : void 0,
        ...e.style
      },
      children: b && t
    }
  );
});
function x(e) {
  return e ? "open" : "closed";
}
var U = T, V = w, W = A;
export {
  A as C,
  U as R,
  V as T,
  w as a,
  W as b,
  Q as c
};
